import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  SvgIcon
} from '../'

export const Notification = ({ type, message, closeIcon, onCloseClick, className }) => (
  <div
    className={`${className ? `${className} ` : ''}slds-notify slds-notify_alert slds-theme_alert-texture ${type === "info"
      ? "slds-theme_info"
      : type === "warning"
        ? "slds-theme_warning"
        : "slds-theme_error"}`}
    role="alert">
    <span className="slds-assistive-text">notification</span>
    <SvgIcon
      variant="utility"
      symbol={(type === "error" ? "warning" : type) || "event"}
      size="small"
      colour="inverse"
      className='slds-m-right_xxx-small'
    />
    {message}
    {closeIcon &&
      <Button
        type="reset"
        onClick={onCloseClick}
        className="slds-button_icon slds-notify__close slds-m-left_small"
        title="Close">
        <SvgIcon
          variant="utility"
          symbol="close"
          size="small"
          colour="inverse"
        />
        <span className="slds-assistive-text">Close</span>
      </Button>
    }
  </div>
)

Notification.propTypes = {
  type: PropTypes.oneOf([ 'info', 'warning', 'error' ]),
  message: PropTypes.string,
  closeIcon: PropTypes.bool,
  onCloseClick: PropTypes.func,
  className: PropTypes.string
}

Notification.defaultProps = {
  closeIcon: true
}



// WEBPACK FOOTER //
// ./src/components/notification/index.js